var BrowseErrorHtml, BrowseErrorMessageTemplate, BrowseErrorPresenter;

BrowseErrorPresenter = require('../presenters/error');

BrowseErrorMessageTemplate = require('../../error_message.html.mustache');

module.exports = BrowseErrorHtml = function() {
  var hash, presenter;
  presenter = new BrowseErrorPresenter;
  hash = presenter.toHash();
  return BrowseErrorMessageTemplate.render(hash);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2Jyb3dzZS9mcm9udGVuZC92aWV3cy9lcnJvci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9hZGNhYmFsbGVyby9uYXBpc3RyYW5vL2J1aWxkLzE0OTI0Njc5NzUzNzktMzc5NTIvc3RhZ2luZy0yMDE3LjA0LjE3XzIyLjE1L2dvb2RzL21vZHVsZXMvYnJvd3NlL2Zyb250ZW5kL3ZpZXdzL2Vycm9yLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLG9CQUFBLEdBQXVCLE9BQUEsQ0FBUSxxQkFBUjs7QUFDdkIsMEJBQUEsR0FBNkIsT0FBQSxDQUFRLG1DQUFSOztBQUU3QixNQUFNLENBQUMsT0FBUCxHQUFpQixlQUFBLEdBQWtCLFNBQUE7QUFDakMsTUFBQTtFQUFBLFNBQUEsR0FBWSxJQUFJO0VBQ2hCLElBQUEsR0FBTyxTQUFTLENBQUMsTUFBVixDQUFBO1NBQ1AsMEJBQTBCLENBQUMsTUFBM0IsQ0FBa0MsSUFBbEM7QUFIaUMifQ==
